"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pagination;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrowLeft = _interopRequireDefault(require("@decisiv/iconix/lib/components/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("@decisiv/iconix/lib/components/ArrowRight"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Pages = _interopRequireDefault(require("./Pages"));

var _NextPrevButton = _interopRequireDefault(require("./NextPrevButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Pagination(props) {
  var variant = props.variant,
      defaultActivePage = props.defaultActivePage,
      activePage = props.activePage,
      totalPages = props.totalPages,
      onPageChange = props.onPageChange,
      labelPrevious = props.labelPrevious,
      labelNext = props.labelNext;
  var translate = (0, _useTranslations.default)();
  var startPage = activePage || defaultActivePage || 1;

  var _useState = (0, _react.useState)(startPage),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  if (totalPages <= 1) return null;
  var activePageIsControlled = typeof activePage !== 'undefined';

  if (activePageIsControlled && activePage !== currentPage) {
    setCurrentPage(startPage);
  }

  var prevPage = currentPage > 1 ? {
    page: currentPage - 1
  } : undefined;
  var nextPage = currentPage < totalPages ? {
    page: currentPage + 1
  } : undefined;
  var prevButtonAriaLabel = prevPage ? translate(labelPrevious, 'pagination.aria.previous', {
    page: "".concat(prevPage.page)
  }) : undefined;
  var nextButtonAriaLabel = nextPage ? translate(labelPrevious, 'pagination.aria.next', {
    page: "".concat(nextPage.page)
  }) : undefined;

  var pageChangeHandler = function pageChangeHandler(page) {
    /* istanbul ignore else */
    if (page.page) {
      if (onPageChange) {
        onPageChange(page.page, currentPage);
      }

      setCurrentPage(page.page);
    }
  };

  return _react.default.createElement(_Flex.default, {
    as: "nav",
    role: "navigation",
    "aria-label": translate(undefined, 'pagination.aria.label')
  }, _react.default.createElement(_NextPrevButton.default, {
    variant: variant,
    text: translate(labelPrevious, 'pagination.previous'),
    ariaLabel: prevButtonAriaLabel,
    icon: _ArrowLeft.default,
    page: prevPage,
    pageChangeHandler: pageChangeHandler
  }), _react.default.createElement(_Pages.default, {
    variant: variant,
    currentPage: currentPage,
    totalPages: totalPages,
    onPageChange: pageChangeHandler
  }), _react.default.createElement(_NextPrevButton.default, {
    variant: variant,
    text: translate(labelNext, 'pagination.next'),
    ariaLabel: nextButtonAriaLabel,
    icon: _ArrowRight.default,
    iconPosition: "right",
    page: nextPage,
    pageChangeHandler: pageChangeHandler
  }));
}

Pagination.propTypes = {
  variant: _propTypes.default.oneOf(['comfortable', 'compact']),
  defaultActivePage: _propTypes.default.number,
  activePage: _propTypes.default.number,
  totalPages: _propTypes.default.number.isRequired,
  onPageChange: _propTypes.default.func,
  labelPrevious: _propTypes.default.string,
  labelNext: _propTypes.default.string
};
var defaultProps = {
  variant: 'comfortable',
  defaultActivePage: 1,
  activePage: undefined,
  onPageChange: undefined,
  labelPrevious: undefined,
  labelNext: undefined
};
Pagination.defaultProps = defaultProps;